export const gpsStatusIcons: any = {
  developing_artist: {
    id: 'developing_artist',
    color: '#40B4B8',
    description: 'Developing Artist',
    tag: '#developing-artist'
  },
  established_artist: {
    id: 'established_artist',
    color: '#7A7AC7',
    description: 'Established Artist',
    tag: '#establish-artist'
  },
  superstar_artist: {
    id: 'superstar_artist',
    color: '#1A9650',
    description: 'Superstar Artist',
    tag: '#superstar'
  },
  surgingtrack: {
    id: 'surging_track',
    color: '#FF8153',
    description: 'Surging Track',
    tag: '#surging-track'
  },
  trackoftheweek: {
    id: 'track_of_the_week',
    color: '#FF2828',
    description: 'Track Of Week',
    tag: '#track-of-week'
  },
  radar: {
    id: 'radar',
    color: '#AF01C8',
    description: 'Radar',
    tag: '#radar'
  }
}
